import Card from './ui/Card';

type IconType = 'save' | 'upload' | 'lock' | 'eye';

interface ReassuranceItem {
  icon: IconType;
  text: string;
}

interface ReassurancePanelProps {
  title: string;
  items: ReassuranceItem[];
}

function Icon({ type }: { type: IconType }) {
  const iconClass = "w-5 h-5 text-emerald-600 shrink-0";
  
  switch (type) {
    case 'save':
      return (
        <svg className={iconClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      );
    case 'upload':
      return (
        <svg className={iconClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
        </svg>
      );
    case 'lock':
      return (
        <svg className={iconClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      );
    case 'eye':
      return (
        <svg className={iconClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      );
  }
}

export default function ReassurancePanel({ title, items }: ReassurancePanelProps) {
  return (
    <Card variant="subtle">
      <h3 className="text-lg font-semibold text-slate-950">{title}</h3>
      <ul className="mt-4 space-y-3">
        {items.map((item, index) => (
          <li key={index} className="flex items-start gap-3">
            <Icon type={item.icon} />
            <span className="text-sm text-slate-700">{item.text}</span>
          </li>
        ))}
      </ul>
    </Card>
  );
}

export type { ReassuranceItem, IconType };
